import { getStaticGuideBySlug } from '../data/guideCatalog';

/**
 * Legacy guide URL slugs Google still crawls (soft 404) → current canonical slugs.
 * Heuristic also strips stray "-and-" segments when a matching guide exists.
 */
export const GUIDE_SLUG_ALIASES = {
	'understanding-nepal': 'understanding-nepals-festival-calendar',
	'common-tourist-scams-and-how-to-avoid-them': 'common-tourist-scams-how-to-avoid-them',
	'getting-to-lukla-and-the-everest-region': 'getting-to-lukla-the-everest-region',
	'getting-around-kathmandu-and-pokhara': 'getting-around-kathmandu-pokhara',
	'altitude-sickness-prevention-and-response': 'altitude-sickness-prevention-response',
	'drone-and-filming-permits-in-nepal': 'drone-filming-permits-in-nepal',
	'tims-card-and-trekking-permits': 'tims-card-trekking-permits',
};

/** Map request slug → canonical published slug (or same slug if already canonical). */
export function resolveGuideSlug(slug) {
	if (!slug) return slug;
	if (GUIDE_SLUG_ALIASES[slug]) return GUIDE_SLUG_ALIASES[slug];

	// Older sitemap/API slugs often kept the word "and" between terms.
	const withoutAnd = slug.replace(/-and-/g, '-');
	if (withoutAnd !== slug && getStaticGuideBySlug(withoutAnd)) return withoutAnd;

	return slug;
}

export function isGuideSlugAlias(slug) {
	const canonical = resolveGuideSlug(slug);
	return canonical !== slug;
}
